import { BaseComponent } from '@cinch-nx/data-storyblok'
import { CarsCarousel } from '@cinch-nx/shared-cars-carousel'
import { Wrapper } from '@cinch-nx/shared-ui'
import { StoryblokRenderer } from '../../../storyblok-renderer/storyblok-renderer'
import { ComponentMap } from '../../../storyblok-renderer/types'
import styles from './cars-carousel-section.module.css'

export interface CarsCarouselSectionBlock extends BaseComponent {
  component: 'CarsCarouselSection'
  carsCarousel: BaseComponent & { component: 'CarsCarousel' }
}

const storyblokComponents: ComponentMap = {
  CarsCarousel: CarsCarousel,
}

export const CarsCarouselSection: React.FC<CarsCarouselSectionBlock> = ({
  carsCarousel,
}) => (
  <Wrapper
    className={{
      container: styles.container,
      inner: styles.innerWrapper,
    }}
  >
    <StoryblokRenderer block={carsCarousel} components={storyblokComponents} />
  </Wrapper>
)
